export default function userPendencyQuery() {
  const query = `{
        userPendency {
            smartGoPendency,
            totalMedicalPendencyQuantity,
            lateMedicalPendencyQuantity,
            unreadChatMessages,
            communicationPendency,
            routineRecordsPendency,
            chatSummary {
              senderId,
              recipientId,
              amount,
              updatedAt
            }
        }		
    }`;
  return query;
}
